import * as C from '@/consts'
import * as a from '@/libs/a'
import logo from '@/assets/card-brands/discover-logomark-img-08.gif'

export default {
  // ブランドコード
  code: C.BRAND_DISCOVER,

  // ブランド判定
  match (number) {
    // 60110, 60112-60114, 601174 - 601179, 601186 - 601199, 644 - 649, 65
    const prefix = (number + '000000').slice(0, 6) | 0

    const result =
      a.between(prefix, 601100, 601109) ||
      a.between(prefix, 601120, 601149) ||
      a.between(prefix, 601174, 601179) ||
      a.between(prefix, 601186, 601199) ||
      a.between(prefix, 644000, 649999) ||
      a.between(prefix, 650000, 659999) ||
      false
    return result
  },

  // カード番号のパターン
  pattern: [4, 4, 4, 4],

  // ロゴ
  logo
}
